import Card from "components/card";
import BarChart from "components/charts/BarChart";
import {
  barChartDataWeeklyRevenue,
  barChartOptionsWeeklyRevenue,
} from "variables/charts";
import { MdBarChart } from "react-icons/md";
import { useEffect, useState } from "react";

const ReportsWithType = (props: any) => {
  const [chartColors, setChartColors] = useState(["#7551ff", "#422afb"]);

  useEffect(() => {
  }, [props.data])

  useEffect(() => {
    const updateChartColors = () => {
      const styles = getComputedStyle(document.documentElement);
      const primary = styles.getPropertyValue("--color-brand-500").trim();
      const secondary = styles.getPropertyValue("--color-brand-400").trim();
      setChartColors([
        secondary || "#7551ff",
        primary || "#422afb",
      ]);
    };

    updateChartColors();
    const observer = new MutationObserver(updateChartColors);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["style", "class"] });
    return () => observer.disconnect();
  }, []);

  const hasTrial = Array.isArray(props.data.trial);
  const hasSubscribed = Array.isArray(props.data.subscribed);
  const hasData = hasTrial || hasSubscribed;

  const info = hasData ? [
    {
      name: "Trial",
      data: hasTrial ? props.data.trial : [],
      color: chartColors[0],
    },
    {
      name: "Subscribed",
      data: hasSubscribed ? props.data.subscribed : [],
      color: chartColors[1],
    }
  ] : [];

  return (
    <Card extra="flex flex-col w-full rounded-3xl py-6 px-2 text-center">
      <div className="mb-auto flex items-center justify-between px-6">
        <h2 className="text-lg font-bold text-textPrimary">
          Trial vs Subscribed Users
        </h2>
        <button className="!linear z-[1] flex items-center justify-center rounded-lg bg-surfaceSecondary p-2 text-brand-500 !transition !duration-200 hover:bg-surfaceSecondary/80 active:bg-surfaceSecondary/70">
          <MdBarChart className="h-6 w-6" />
        </button>
      </div>

      <div className="md:mt-16 lg:mt-0">
        <div className="h-[250px] w-full xl:h-[350px]">
          {
            hasData ? <BarChart
              chartData={info}
              chartOptions={{
                ...barChartOptionsWeeklyRevenue,
                colors: chartColors,
                fill: { ...barChartOptionsWeeklyRevenue.fill, colors: chartColors },
              }}
            /> : null
          }
        </div>
      </div>
    </Card>
  );
};

export default ReportsWithType;
